import { HTTP_STATUS_SUCCESS_CODES } from "./constants/apis";

/**
 * Checks if an HTTP request is successful based on the status code.
 *
 * @param {number} statusCode - The HTTP status code to check.
 * @returns {boolean} True if the status code indicates success, otherwise false.
 */
export function isRequestSuccessful(statusCode: number) {
  return Object.values(HTTP_STATUS_SUCCESS_CODES).includes(statusCode);
}
